import { Box} from '@mui/material';
import React from 'react';
import HeadTittle from "../../../components/HeadTittle";
import {CustomSelect} from "../../../components/CustomSelect";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../components/buttons/IconButtons";
import DocumentRestrictionApp from "./Functionality/DocumentRestrictionApp";
const DocumentRestriction = () => {
    const { t,
        value,
        setValue,
        emptyFields,
        navigate,
        handleUpdateDoc,
        getDocumentRestriction
    } = DocumentRestrictionApp();
    return (<>
            <HeadTittle link={"#"} onBack={() => navigate(-1)} name={'DOCUMENT_RESTRICTION'}>
                <ButtonAction
                    id='btn_dr_update'
                    name='update'
                    className='btn-icon-add'
                    Icon={EditIcon}
                    onClick={() => handleUpdateDoc()}
                />

            </HeadTittle>
            <div className={"row mt-4"}>
                <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                    <CustomSelect id={"slt_dr_restriction"}
                                  name={"restriction"}
                                  value={value}
                                  keyName="id"
                                  onChange={(e) => setValue(e.target.value)}
                                  list={getDocumentRestriction}
                                  trans={"notify_department_through"}
                                  label={"lbl_dr_restriction"}
                                  emptyFields={emptyFields}
                                  required={true}
                                  showNoSelectionOption={false}
                    />
                </Box>
            </div>
        </>
    );
};

export default DocumentRestriction;
